import { Injectable, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { checkVonageCompatibility, detectBrowser, detectDevice } from 'src/libs/browser-compat';

@Injectable({ providedIn: 'root' })
export class EnvironmentDetectionService {
  readonly browserInfo = toSignal(detectBrowser(), { initialValue: null });
  readonly deviceInfo = toSignal(detectDevice(), { initialValue: null });

  readonly compatibility = computed(() => {
    const browserInfo = this.browserInfo();
    return browserInfo ? checkVonageCompatibility(browserInfo) : null;
  });

  readonly isSupported = computed(() => this.compatibility()?.isSupported ?? false);
}
